<template>
    <div class="tenjityModule-item-visualZoom-settings">
        <!-- Zoom de la page -->
        <div class="tenjityModule-item tenjityModule-item-subitem"
            :class="{ 'tenjityModule-item-active': isZoomActive }">
            <div class="tenjityModule-item-header" @click="toggleZoom">
                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-zoom" icon="fluent:search-32-filled" />
                <div class="tenjityModule-item-name-small" role="button">Zoom de la page</div>
                <div class="tenjityModule-item-right"></div>
            </div>
            <div class="tenjityModule-item-textZoom-slider" @click.stop>
                <input type="range" class="tenjityModule-item-textZoom-range" :min="zoomMin" :max="zoomMax"
                    :step="zoomStep" :value="isZoomActive ? zoomValue : 100" :style="{ background: pageZoomSliderBg }"
                    @input.stop="onPageZoomSlider($event)"
                    :aria-label="`Zoom de la page : ${isZoomActive ? zoomValue : 100}%`"
                    :aria-valuenow="isZoomActive ? zoomValue : 100" :aria-valuemin="zoomMin" :aria-valuemax="zoomMax" />
                <span class="tenjityModule-item-textZoom-value">{{ isZoomActive ? zoomValue : 100 }}%</span>
            </div>
        </div>
        <!-- Zoom du module -->
        <div class="tenjityModule-item tenjityModule-item-subitem"
            :class="{ 'tenjityModule-item-active': isModuleZoomActive }">
            <div class="tenjityModule-item-header" @click="toggleModuleZoom">
                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-zoom"
                    icon="fluent:window-resize-24-regular" />
                <div class="tenjityModule-item-name-small" role="button">Zoom du module</div>
                <div class="tenjityModule-item-right"></div>
            </div>
            <div class="tenjityModule-item-textZoom-slider" @click.stop>
                <input type="range" class="tenjityModule-item-textZoom-range" :min="moduleZoomMin" :max="moduleZoomMax"
                    :step="moduleZoomStep" :value="isModuleZoomActive ? moduleZoomValue : 100"
                    :style="{ background: moduleZoomSliderBg }" @input.stop="onModuleZoomSlider($event)"
                    :aria-label="`Zoom du module : ${isModuleZoomActive ? moduleZoomValue : 100}%`"
                    :aria-valuenow="isModuleZoomActive ? moduleZoomValue : 100" :aria-valuemin="moduleZoomMin"
                    :aria-valuemax="moduleZoomMax" />
                <span class="tenjityModule-item-textZoom-value">{{ isModuleZoomActive ? moduleZoomValue : 100
                    }}%</span>
            </div>
        </div>
        <!-- Zoom du texte -->
        <div class="tenjityModule-item tenjityModule-item-subitem"
            :class="{ 'tenjityModule-item-active': isTextZoomActive }">
            <div class="tenjityModule-item-header">
                <Icon class="tenjityModule-item-icon tenjityModule-item-icon-zoom"
                    icon="fluent:font-increase-20-regular" />
                <div class="tenjityModule-item-name-small">Zoom du texte</div>
                <div class="tenjityModule-item-right">
                    <Icon v-if="isTextZoomActive" @click.stop="resetTextZoom"
                        class="tenjityModule-item-icon tenjityModule-item-icon-reset"
                        icon="fluent:arrow-counterclockwise-20-regular" role="button"
                        aria-label="Réinitialiser le zoom du texte" />
                </div>
            </div>
            <div class="tenjityModule-item-textZoom-slider">
                <span class="tenjityModule-item-textZoom-label tenjityModule-item-textZoom-label-small"
                    aria-hidden="true">A</span>
                <input type="range" class="tenjityModule-item-textZoom-range" :min="textZoomMin" :max="textZoomMax"
                    step="5" :value="isTextZoomActive ? textZoomValue : 100" :style="{ background: textZoomSliderBg }"
                    @input.stop="onTextZoomSlider($event)"
                    :aria-label="`Zoom du texte : ${isTextZoomActive ? textZoomValue : 100}%`"
                    :aria-valuenow="isTextZoomActive ? textZoomValue : 100" :aria-valuemin="textZoomMin"
                    :aria-valuemax="textZoomMax" />
                <span class="tenjityModule-item-textZoom-label tenjityModule-item-textZoom-label-large"
                    aria-hidden="true">A</span>
                <span class="tenjityModule-item-textZoom-value">{{ isTextZoomActive ? textZoomValue : 100
                    }}%</span>
            </div>
        </div>
    </div>
</template>

<script>
import { Icon } from "@iconify/vue";
export default {
    name: "AccessibilityZoom",
    components: { Icon },
    props: {
        isZoomActive: Boolean,
        zoomValue: Number,
        zoomMin: Number,
        zoomMax: Number,
        zoomStep: Number,
        isModuleZoomActive: Boolean,
        moduleZoomValue: Number,
        moduleZoomMin: Number,
        moduleZoomMax: Number,
        moduleZoomStep: Number,
        isTextZoomActive: Boolean,
        textZoomValue: Number,
        textZoomMin: Number,
        textZoomMax: Number,
        pageZoomSliderBg: String,
        moduleZoomSliderBg: String,
        textZoomSliderBg: String,
        toggleZoom: Function,
        onPageZoomSlider: Function,
        toggleModuleZoom: Function,
        onModuleZoomSlider: Function,
        onTextZoomSlider: Function,
        resetTextZoom: Function,
    },
};
</script>

<style lang="scss" scoped></style>
